import { get, makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CuotasMod, CuotasModFormValues } from '../models/CuotasMod';
import {CCTPlanCuotaDetails, CCTPlanCuotaDetailsForm} from '../models/CCTPlanCuota';
import { DPI, DPIFormValues } from '../models/dpi';
import { CATCursosL, createCATCursos } from '../models/CATCursos';
import { CATEdiciones, CATEdicionesL } from '../models/CATEdiciones';
import {getTranxTipoCta} from '../models/getTranxTipoCta';
import { MontoCuota } from '../models/montoCuota';



export default class CuotasStore {
    CCTOperacionRegistry = new Map<any, CuotasMod>();
    CATCoursesRegistry = new Map<any,createCATCursos>();
    CATCoursesRegistryL = new Map<any,CATCursosL>();

    CATEdicionesRegistry = new Map<any,CATEdiciones>();
    CATEdicionesRegistry3 = new Map<any,CATEdicionesL>();
    TransXTipoCta = new Map<any,getTranxTipoCta>();
   
    DPIRegistry = new Map<any, CuotasMod>();

    DetailedCuotasRegistry = new Map<any,CCTPlanCuotaDetails>();
    DetailedCuotas = new Map<any,CCTPlanCuotaDetails>();
    

    selectedCuotasMod: CuotasMod | undefined = undefined;
    selectedDPI: DPI | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    consulta=''; 


    constructor() {
        makeAutoObservable(this)
    }

    get PlanCuotas() {
        return Array.from(this.CCTOperacionRegistry.values());
    }

    get CATCoursesInfo(){
        return Array.from(this.CATCoursesRegistry.values());
    }
    // get dpiByCodigo() {
         
    //     return Array.from(this.DPIRegistry.values());
    // }

    get detailedCuotas(){
        return Array.from(this.DetailedCuotasRegistry.values());
    }
    get detailedCuotas2(){
        return Array.from(this.DetailedCuotas.values());
    }

    get groupedCCTMovimientos() {
        return this.CCTOperacionRegistry
    }
    loadEditions = async(codigocurso:number)=>{
        if(codigocurso==undefined){
            codigocurso=0;
        }
        try{
            const getEditions:CATEdiciones[]=await agent.getCATEdiciones.getEditionsByCourse(codigocurso);
            return Array.from(getEditions);
        }catch{
            return Array.from(this.CATEdicionesRegistry.values());
        }

    }

    loadCoursesL = async()=>{
        const getCursos:CATCursosL[] = await agent.CATCursos.getCoursesL();
        return Array.from(getCursos);
        
     }


    loadEditions2 = async(id:number)=>{
        if(id==undefined){
            id=0;
        }
        try{
            const getEditions:CATEdicionesL[]=await agent.getCATEdiciones.getEditionsByCourse2(id);
            return Array.from(getEditions);
        }catch{
            return Array.from(this.CATEdicionesRegistry3.values());
        }

    }


    

    loadTransXTipoCta = async(codigocuenta:string)=>{
        try{
            const getTrans:getTranxTipoCta[]= await agent.CCTTiposTransXTipoCtas.movimientos(codigocuenta);
            return Array.from(getTrans);            
        }catch{
            return Array.from(this.TransXTipoCta.values());
        }

    }

     loadCourses = async()=>{
        const getCursos:createCATCursos[] = await agent.CATCursos.getCourses();
        return Array.from(getCursos);
     }

    

     loadCuotass = async(catCursoId: string, catEdicionId: string)=>{
         try{
             
            const consulta:CuotasMod[] =  await agent.Cuotas.details(catCursoId, catEdicionId);
            const consultaData = Array.from(consulta)
          
                    consultaData.forEach(element =>{
                        this.setCuotass(element);
                    })
                    return Array.from(consulta.values())   
                              
         }catch{             

            return Array.from(this.DPIRegistry.values())
            }
        
     } 
     
     LoadCuotasDetail = async(catCursoId: string, catEdicionId: string)=>{
        try{ 
            this.DetailedCuotas.clear()           
           const consulta:CCTPlanCuotaDetails[] =  await agent.Cuotas.ListCuotasDetail(catCursoId, catEdicionId);
           const consultaData = Array.from(consulta)         
                   consultaData.forEach(element =>{
                       this.setCuotasss(element);
                   })
                   this.setLoadingInitial(false);
                   return Array.from(consulta)                             
        }catch{   
            this.setLoadingInitial(false);          

           return Array.from(this.DetailedCuotas.values())
           }
       
    }



     loadCuotasList = async()=>{
        try{
       const listCuotas:CuotasMod[] = await agent.Cuotas.listCuotas();
     
       listCuotas.forEach(element => {
           this.setCuotasList(element);
       })

       return Array.from(listCuotas);
   }catch{
       return Array.from(this.CCTOperacionRegistry.values())
   }
    }

    
    loadCuotasListDetailed = async()=>{

        this.loadingInitial = true;
        try{

            const listCuotasDetailed:CCTPlanCuotaDetails[] = await agent.Cuotas.listDetailedCuotas();
            listCuotasDetailed.forEach(element => {
                this.setCuotasDetailedList(element);
            })

            this.setLoadingInitial(false);

            return Array.from(listCuotasDetailed);
        }catch{
            this.setLoadingInitial(false);
            return Array.from(this.DetailedCuotasRegistry.values())
        }
    }

     loadCuotas = async (catCursoId: string, catEdicionId: string) => {
        let CConsulta = this.getConsulta(catCursoId);
        this.CCTOperacionRegistry.clear()
        if (CConsulta) {
            this.CCTOperacionRegistry.clear()
            this.selectedCuotasMod = CConsulta;
            return CConsulta;
        } else {
            this.loadingInitial = true;
            try {
                this.CCTOperacionRegistry.clear()
                const getCursos:createCATCursos[] = await agent.CATCursos.getCourses();
                const consulta: CuotasMod[] =  await agent.Cuotas.details(catCursoId, catEdicionId);

                
                // consulta.forEach(data => {
                //     this.setCuotass(data);
                // })
                runInAction(() => {
                    this.selectedCuotasMod = CConsulta || this.selectedCuotasMod;
                })                  
               
                this.setLoadingInitial(false);
                return CConsulta;
               
            } catch (error) { 
                this.setLoadingInitial(false);
            }
        }
    }      

    private setCuotass = (id: CuotasMod) => {
               this.DPIRegistry.set(id.id, id);


    }


    private setCuotasss = (id: CCTPlanCuotaDetails) => {
        this.DetailedCuotas.set(id.id, id);

     
}
    private setCuotasList = (id: CuotasMod) => {
        this.DPIRegistry.set(id.id, id);
    
}

    private setCuotasDetailedList = (id:CCTPlanCuotaDetails)=>{
        this.DetailedCuotasRegistry.set(id.id,id);
    }
   
    private getConsulta = (id: any) => {
        return this.DPIRegistry.get(id);    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCuotasMod = async (CuotasMod: CuotasModFormValues) => {
        try {
            await agent.Cuotas.create(CuotasMod);
            runInAction(() => {
                this.selectedCuotasMod = CuotasMod;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    getCuota = async (catEdicionesId: number) => {

        this.loadingInitial = true;
        try {
            const cuotas: MontoCuota[] = await agent.Cuotas.getCuota(catEdicionesId);
            runInAction(() => {
                this.setLoadingInitial(false)
                
            })
            console.log("recibiendo arancel: ", cuotas[0].arancel);
            
            return cuotas[0].arancel
        } catch (error) {
            runInAction(() => {
                this.setLoadingInitial(false)
            })
            return 0;
        }
    }
   

}

export const CoursesData = async () => {
    try{
        const getCursos:createCATCursos[] = await agent.CATCursos.getCourses();
    }
    catch{
    }
}




